import React from "react";
import { Button, Box, Typography, Slider } from "@mui/material";
import { useSpeech } from "../utils/speech";

const SettingsScreen = ({ goBack }) => {
  const { speechRate, setSpeechRate } = useSpeech();

  const handleRateChange = (event, newValue) => {
    setSpeechRate(newValue);
  };

  return (
    <Box id="settingsScreen" className="screen" sx={{ p: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        設定
      </Typography>
      <Box className="setting-item" sx={{ mb: 3 }}>
        <Typography id="speech-rate-slider" gutterBottom>
          語速:
        </Typography>
        <Slider
          aria-labelledby="speech-rate-slider"
          value={speechRate}
          onChange={handleRateChange}
          min={0.1}
          max={2.0}
          step={0.1}
          valueLabelDisplay="auto"
          marks
        />
        <Typography variant="body1">{speechRate.toFixed(1)}</Typography>
      </Box>
      <Button variant="contained" onClick={goBack}>
        返回主目錄
      </Button>
    </Box>
  );
};

export default SettingsScreen;
